import axiosClient from "./axiosClient";

export const getAdminOrders = async () => {
  const response = await axiosClient.get("/admin/orders");

  return response.data;
};

export const getAdminOrderById = async (id) => {
  const response = await axiosClient.get(`/admin/orders/${id}`);

  return response.data;
};

export const updateAdminOrderStatus = async (id, status) => {
  const response = await axiosClient.put(`/admin/orders/${id}/status`, null, {
    params: {
      status,
    },
  });

  return response.data;
};
